import {Model} from "@vuex-orm/core";

export default class UserBuddy extends Model {

    static entity = 'UserBuddy';

    static primaryKey = ['user_id', 'buddy_id'];

    static fields () {
        return {
            user_id: this.number(null).nullable(),
            buddy_id: this.number(null).nullable(),
        }
    }
}
